import { type Condition } from '@repo/api-gw-sdk';

import { convertQuery } from '@/components/cost-explorer/utils/queryUtils';
import { useDAL } from '@/contexts/useDAL';
import { createCombineCondition } from '@/types/advanceFilter';

export const useRestoreAccounts = (condition?: Condition) => {
  const dal = useDAL();
  return dal.cloudAccounts.restore.useList(
    undefined,
    undefined,
    condition
      ? { filters: convertQuery(createCombineCondition([condition])) }
      : {}
  );
};
